import { AbstractControl, FormGroup, UntypedFormArray, UntypedFormGroup, ValidationErrors } from '@angular/forms';

export const patchErrors = (form: UntypedFormGroup, errors: any[]) => {
    for (let key in errors) {

        let control = form?.get(key);

        if (control) {
            control.markAsTouched();
            control.setErrors({ api: errors[key] });
        }
    }
};

/** Prefer first Laravel validation message over the generic 422 summary. */
export function firstApiErrorMessage(error: any, fallback = 'Erreur'): string {
    const fieldErrors = error?.errors;
    if (fieldErrors && typeof fieldErrors === 'object') {
        for (const messages of Object.values(fieldErrors)) {
            if (Array.isArray(messages) && messages.length > 0 && typeof messages[0] === 'string') {
                return messages[0];
            }
        }
    }

    if (typeof error?.message === 'string' && error.message.trim() !== '') {
        const identifier = identifierFromErrors(fieldErrors);
        if (identifier && identifier !== error.message) {
            return `${identifier}: ${error.message}`;
        }

        return error.message;
    }

    if (fieldErrors && typeof fieldErrors === 'object') {
        for (const messages of Object.values(fieldErrors)) {
            if (typeof messages === 'string' && messages.length > 0) {
                return messages;
            }
        }
    }

    return fallback;
}

function identifierFromErrors(fieldErrors: any): string | null {
    if (!fieldErrors || typeof fieldErrors !== 'object') {
        return null;
    }

    for (const key of ['sku', 'id']) {
        const value = fieldErrors[key];
        const text = value == null ? '' : String(value).trim();
        if (text !== '' && !/\s/.test(text)) {
            return text;
        }
    }

    return null;
}

export interface FieldError {
    field: string;
    errors: ValidationErrors;
}

export function getFormErrors(
    control: AbstractControl,
    key = ''
): FieldError[] {
    const result: FieldError[] = [];

    if (control.errors) {
        result.push({ field: key || '(root)', errors: control.errors });
    }

    if (control instanceof UntypedFormGroup) {
        for (const [name, child] of Object.entries(control.controls)) {
            const childKey = key ? `${key}.${name}` : name;
            result.push(...getFormErrors(child, childKey));
        }
    } else if (control instanceof UntypedFormArray) {
        control.controls.forEach((child, i) => {
            const childKey = `${key}[${i}]`;
            result.push(...getFormErrors(child, childKey));
        });
    }

    return result;
}
